import styles from './StatusBadge.module.css'

export type Tone = 'success' | 'danger' | 'warning' | 'info' | 'neutral'

export interface StatusBadgeProps {
  readonly tone: Tone
  /** Already-translated, human-readable label. Badges never translate their
   *  own text: the raw upstream status codes are an API vocabulary, and the
   *  mapping from code to tone and label belongs with the screen that knows
   *  which API it is talking to. */
  readonly children: string
}

const GLYPH: Record<Tone, string> = {
  success: '●',
  danger: '▲',
  warning: '◆',
  info: '■',
  neutral: '○',
}

export function StatusBadge({ tone, children }: StatusBadgeProps) {
  return (
    <span className={[styles.badge, styles[tone]].filter(Boolean).join(' ')}>
      <span className={styles.glyph} aria-hidden="true">
        {GLYPH[tone]}
      </span>
      {children}
    </span>
  )
}
